import React, { useState } from 'react'
import useMonthlyReportStyles from './styles'
import ReortTable from '../ReortTable/ReortTable'
import { Box, Grid } from '@mui/material'
import MonthlyInverterGraph from '../MonthlyInverterGraph/MonthlyInverterGraph'
import LogoP1 from '../../../../assets/images/de-logo.svg'
import moment from 'moment'
import CircularProgress from '@mui/material/CircularProgress'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import '../../businessview-style.scss'
const MonthlyReport = ({ monthlyReportList, state, fromDate, toDate }) => {
  const classes = useMonthlyReportStyles()

  const containerStyle = {
    position: 'relative',
    backgroundColor: 'white',
    padding: '50px',
  }

  const containerNewStyle = {
    position: 'relative',
    backgroundColor: 'white',
    padding: '60px',
    width: '250mm',
  }
  const triangleStyle = {
    content: '',
    position: 'absolute',
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    borderTop: '500px solid #12487e', // Change the color as desired
    borderRight: '600px solid transparent',
  }
  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
  }
  const thStyle = {
    backgroundColor: '#f2f2f2',
    padding: '8px',
    textAlign: 'left',
  }
  const tdStyle = {
    border: '1px solid #dddddd',
    padding: '8px',
    textAlign: 'left',
  }

  const [mapinverterData, setMapinverterData] = React.useState([])
  const [firstDates, setFirstDates] = useState([])
  const [Loading, setLoading] = useState(false)
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)
  const [isDownloading, setIsDownloading] = useState(false)
  const dataArray = Object.entries(monthlyReportList?.data).map(
    ([month, values]) => ({
      month,
      ...values,
    })
  )
  const FiltereddeemedData = (data) => {
    return data.length > 0 ? (
      data?.map((Data) => (
        <tr>
          <td style={tdStyle}>{moment(Data?.logDate).format('DD-MM-YYYY')}</td>
          <td style={tdStyle}>{Data?.faultType}</td>
          <td style={tdStyle}>{Data?.energyLoss}</td>
          <td style={tdStyle}>{Data?.description}</td>
        </tr>
      ))
    ) : (
      <tr>
        <td style={tdStyle}>N/A</td>
        <td style={tdStyle}>N/A</td>
        <td style={tdStyle}>N/A</td>
        <td style={tdStyle}>N/A</td>
      </tr>
    )
  }

  const handlePrint = () => {
    setIsDownloading(true)
    let pdf = new jsPDF('p', 'mm', 'a4')
    const imageCanvasPromises = dataArray.map((Data, index) => {
      const element = document.getElementById(`divToPrint-${index}`)
      return html2canvas(element).then((canvas) => {
        const imgData = canvas.toDataURL('image/png')
        const imgProps = pdf.getImageProperties(imgData)
        // Get the width and height of the element to be printed
        const elementWidth = element.getBoundingClientRect().width
        const elementHeight = element.getBoundingClientRect().height
        // Calculate the scale factor needed to fit the element to the PDF page width
        const scaleFactor = pdf.internal.pageSize.getWidth() / elementWidth
        // Add the image to the PDF page, scaled to fit the page width
        pdf.addImage(
          imgData,
          'PNG',
          0,
          0,
          pdf.internal.pageSize.getWidth(),
          elementHeight * scaleFactor
        )
        pdf.addPage()
      })
    })
    Promise.all(imageCanvasPromises).then(() => {
      pdf.deletePage(pdf.internal.getNumberOfPages())
      pdf.save('monthly-report.pdf')
      setIsDownloading(false)
    })
  }

  return (
    <div className={classes.root}>
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <button
          style={{
            backgroundColor: 'rgba(89, 104, 183, 0.5)',
            outline: 'none',
            border: 'none',
            boxShadow: ' 4px 4px 30px 1px rgba(0, 0, 0, 0.02)',
            borderRadius: '60px',
            padding: '3px 1px',
            fontSize: '18px',
            minWidth: '120px',
            minHeight: '50px',
            color: 'black',
            marginBottom: '10px',
          }}
          onClick={handlePrint}
        >
          {isDownloading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
              }}
            >
              <div style={{ fontSize: '16px', marginRight: '5px' }}>
                Downloading
              </div>
              <CircularProgress
                style={{ height: '15px', width: '15px', color: 'white' }}
              />
            </div>
          ) : (
            'Download'
          )}
        </button>
      </div>
      <div id="divToPrint">
        {Loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: `${screenHeight - 200}px`,
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <div
            style={{
              width: '100%',
              overflowX: 'auto',
              whiteSpace: 'nowrap',
            }}
          >
            <div>
              {dataArray?.map((Data, index) => (
                <div
                  id={`divToPrint-${index}`}
                  style={containerNewStyle}
                  key={index}
                >
                  <div style={triangleStyle}></div>
                  <div
                    style={{
                      position: 'absolute',
                      top: 10,
                      right: 20,
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      paddingLeft: '20px',
                      paddingRight: '20px',
                    }}
                  >
                    <div
                      style={{
                        height: 50,
                        width: 100,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <img
                        style={{ height: 50, width: 50 }}
                        src={LogoP1}
                        alt="DE logo1"
                      />
                    </div>
                    <div style={{ zIndex: '99999' }}>
                      <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        Distributed Energy
                      </div>
                    </div>
                  </div>
                  <Grid p={4} style={containerStyle} mt={5}>
                    <div>Monthly Generation Report</div>
                    <div>{moment(Data?.date).format('MMMM YYYY')}</div>
                    <div key={index} style={{ marginTop: '50px' }}>
                      {mapinverterData && (
                        <MonthlyInverterGraph
                          mapinverterData={Data?.eToday}
                          mapYieldData={Data?.yieldData}
                          Fromdate={firstDates[index]}
                          key={index}
                        />
                      )}
                    </div>
                    <div style={{ textAlign: 'center', marginTop: '50px' }}>
                      Daily Solar Generated Energy
                    </div>
                    <div
                      style={{
                        width: '100%',
                        whiteSpace: 'normal',
                      }}
                    >
                      <ReortTable monthlyReportList={Data} state={state} />
                    </div>
                    <div style={{ marginTop: '20px' }}>
                      Loss summary:
                      <table style={tableStyle}>
                        <thead>
                          <tr>
                            <th style={thStyle}>Date</th>
                            <th style={thStyle}>Fault Type </th>
                            <th style={thStyle}>Energy loss</th>
                            <th style={thStyle}>Description</th>
                          </tr>
                        </thead>
                        <tbody>{FiltereddeemedData(Data?.log)}</tbody>
                      </table>
                    </div>
                  </Grid>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
MonthlyReport.propTypes = {}

export default MonthlyReport
